module.exports = __webpack_public_path__ + "media/mobile-header-global.caca5978.mp4";